
























































import { Prop, Component, Vue } from "vue-property-decorator";
import AccountingSearchBar from "@/ui/common/components/AccountingSearchBar.vue";
import VToolbar from "@/components/V-Toolbar.vue";
import { isNewProject } from "@/preferences";
import VIconPrint from "@/components/icons/VIconPrint.vue";
import InfiniteLoading, { StateChanger } from "vue-infinite-loading";
import { InvoicePayment } from "@/usecases/accounting/invoice";
import { PurchasePayment } from "@/usecases/accounting/purchase";
import InvoiceStatus from "../components/InvoiceStatus.vue";
import InvoiceStatusNew from "@/ui/order/components/InvoiceStatus.vue";
import EstimateStatus from "../components/EstimateStatus.vue";
import EstimateStatusNew from "@/ui/order/components/EstimateStatus.vue";
import PurchaseStatus from "../components/PurchaseStatus.vue";
import PurchaseStatusNew from "@/ui/order/components/PurchaseStatus.vue";
import StatusOfPurchase from "@/usecases/orders/purchase-status";

@Component({
  components: {
    AccountingSearchBar,
    VToolbar,
    VIconPrint,
    InfiniteLoading,
    InvoiceStatus,
    InvoiceStatusNew,
    EstimateStatus,
    EstimateStatusNew,
    PurchaseStatus,
    PurchaseStatusNew
  },
  methods: {
    isNewProject
  }
})
export default class AccountingComponent extends Vue {
  @Prop({ required: true }) mode!: string;
  @Prop({ required: true }) fields!: [];
  @Prop({ required: true }) items!: [];
  @Prop({ default: () => -1 }) isPositionPrinting!: number;

  infiniteLoadingRef: StateChanger | null = null;

  handleSearch() {
    this.$emit("handleSearch", this.infiniteLoadingRef);
  }

  isNewUrl(item: any) {
    if (isNewProject(item.projectCreated)) {
      return `/projects/${item.projectId}/orders/estimates`;
    }

    return `/projects/${item.projectId}/estimates`;
  }

  createPdf(item: any, index: number) {
    this.$emit("handleCreatePdf", item, index);
  }

  loadInfinite($state: StateChanger) {
    this.infiniteLoadingRef = $state;
    this.$emit("loadInfinite", $state);
  }

  handleShowModal(item: InvoicePayment | PurchasePayment) {
    this.$emit("handleShowModal", item);
  }

  changeStatus(item: any, $event: string) {
    this.$emit("changeStatus", item, $event);
  }

  get showPaymentButton() {
    return ["invoice", "purchase"].includes(this.mode);
  }

  get textPaymentButton() {
    if (this.mode == "invoice") {
      return "入金情報";
    }

    if (this.mode == "purchase") {
      return "支払情報";
    }

    return "";
  }

  getComponentStatus(created: string) {
    if (this.mode == "invoice") {
      return isNewProject(created) ? "InvoiceStatusNew" : "InvoiceStatus";
    }

    if (this.mode == "purchase") {
      return isNewProject(created) ? "PurchaseStatusNew" : "PurchaseStatus";
    }

    if (this.mode == "estimate") {
      return isNewProject(created) ? "EstimateStatusNew" : "EstimateStatus";
    }

    return "";
  }

  disabledStatus(item: any): boolean {
    return item.status === StatusOfPurchase.Invalid;
  }

  isNegative(value: number): boolean {
    if (this.mode == "estimate") return false;
    return value < 0;
  }
}
